export default {
  slug: "datagrip",
  code: "DG",
  label: "DataGrip",
  isIDE: true,
  // No product-wide grid: only backgrounds the catalog marks `showgrid` draw
  // it (social and email 13–16, Sergey 2026-10-15).
  krakenDir: "DataGrip",
  thumbnailColor: "#21D789",
  logoFamily: "data",
  // The code highlight of the Demo Video banners (Figma "YouTube", "Code
  // highlight color" of the product section).
  codeHighlightColor: "#FF45ED",
};
